import{ updatetheme,themedata }  from '../../../../store/theme_data';
import { useSelector } from "react-redux";
import { useEffect,useState } from 'react';
import dayjs from 'dayjs';
import { Typography } from '@mui/material';


export default function Statuscard(props){
    const theme = useSelector((state) => state.themedata.theme)
    const tagcollectionvalue = useSelector((state) => state.mainpagedata.tagcollectionvalues);
    const livedata = useSelector((state) => state.mainpagedata.livedata);

    const [optionsmin, setOptionsMin] = useState(0);
    const [optionsmax, setOptionsMax] = useState(0);
    const [optionstimemin, setOptionsTimeMin] = useState(0);
    const [optionstimemax, setOptionsTimeMax] = useState(0);
    const [widgetnamedisplay, setWidgetName] = useState(0);
    const [value, setValue] = useState(0)
    const [time, setTime] = useState("01-01-1970 00:00:00")
    const [tagarray, setTagarray] = useState([])
    
    //console.log("valuecardprops ",props.widgetprop.props.extended.tagprops[0].tagname)
    
    useEffect(() => {
        const tagProperties = props.widgetprop.props.extended.tagprops;
        console.log("tagProperties ",tagProperties)
        var taglistprop= []
        for(let i=0; i<tagProperties.length; i++) {
            taglistprop.push({
                name: tagProperties[i].discription,
                value: 0,
                tagid: tagProperties[i].tagid
            })
        }
        console.log("taglistprop ",taglistprop)
        setTagarray(taglistprop)

        return () => {
            setTagarray([])
        }
    },[])

    useEffect(() => {
        //const tagProperties = props.widgetprop.props.extended.tagprops;
        var widgetname = props.widgetprop.widgetname;

        const tagProperties = props.widgetprop.props.extended.tagprops;
        console.log("tagProperties ",tagProperties)
        var taglistprop= []
        for(let i=0; i<tagProperties.length; i++) {
            taglistprop.push({
                name: tagProperties[i].discription,
                value: 0,
                tagid: tagProperties[i].tagid
            })
        }
        console.log("taglistprop ",taglistprop)
        setTagarray(taglistprop)

        /*tagProperties.forEach(chartType => {
            
            if (tagcollectionvalue.hasOwnProperty(chartType.tagname)) {
                var nestedvalue = tagcollectionvalue[chartType.tagname]
                //console.log("nested value in cardwidget",nestedvalue)
                var sum = 0.0;
                var min = 10000000000;
                var max = 0.0;
                var mintime = 0.0;
                var maxtime = 0.0;
                var options = { timeZone: "Asia/Kolkata" };
                    for(var i=0;i<nestedvalue.length;i++){
                        if(Number(nestedvalue[i].y) > max){
                            max = Number(nestedvalue[i].y);
                            var currentmaxformatteddate = new Date(nestedvalue[i].x);
                            var maxformatteddate = currentmaxformatteddate.toLocaleDateString('en-us', { ...options, day: "numeric", month: "short", year: "numeric",hour: "numeric",minute: "numeric",second: "numeric" });
                            maxtime = maxformatteddate;
                        }else if(Number(nestedvalue[i].y) < min){
                            min = Number(nestedvalue[i].y);
                            var currentminformatteddate = new Date(nestedvalue[i].x);
                            var minformatteddate = currentminformatteddate.toLocaleDateString('en-us', { ...options, day: "numeric", month: "short", year: "numeric",hour: "numeric",minute: "numeric",second: "numeric" });
                            mintime = minformatteddate
                        }
                    }
                //console.log("inside Card Widget min",min)
                //console.log("inside Card Widget max",max)
                //console.log("inside Card Widget mintime",mintime)
                //console.log("inside Card Widget max",maxtime)
                setOptionsMin(min);
                setOptionsMax(max);
                setOptionsTimeMin(mintime);
                setOptionsTimeMax(maxtime);
              //  setWidgetName(widgetname)
                
            }
        })*/
       
        
    },[props.widgetprop])

    useEffect(() => {
        if(livedata.length) {
            var taglist = [...tagarray]
            //console.log("taglist ",taglist)
            for(let i=0; i<livedata.length; i++) {
                for(let j=0 ;j<taglist.length; j++) {
                    //console.log("value card ",livedata[i].TagId, taglist[j].tagid)
                    if(parseInt(taglist[j].tagid) === parseInt(livedata[i].TagId)) {
                        //console.log("livedata[i].value ",livedata[i].TagId, "   ", livedata[i].value)
                        taglist[j].value = livedata[i].value
                        /*setValue(livedata[i].value.toFixed(3))
                        var date = new Date(livedata[i].timestamp * 1000)
                        var timestamp = (date.getDate() > 9 ? date.getDate() : "0"+date.getDate()) + "-" + (date.getMonth()+1 > 9 ? date.getMonth()+1 : "0"+ date.getMonth()+1) + "-" + date.getFullYear() + " " + (date.getHours() > 9 ? date.getHours() : "0"+date.getHours()) + ":" + (date.getMinutes() > 9 ? date.getMinutes() : "0"+date.getMinutes()) + ":" + (date.getSeconds() > 9 ? date.getSeconds() : "0"+date.getSeconds())
                        setTime(timestamp)*/
                    }
                }
            }
            console.log("taglist ",taglist)
            if(taglist.length) {
                setTagarray(taglist)
            }
            
        }
    },[livedata])

    return(
        <div style={{height: 'calc(100% - 55px)', width: 'calc(100% - 15px)', padding: '10px', overflow: 'auto', display: 'flex', flexDirection: 'row', justifyContent: tagarray.length > 1 ? 'space-between' : 'center', alignItems: 'center', gap: 15}}>
            {
                tagarray.map((tagprop) => {
                    return(
                        <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: 5}}>
                            <Typography style={{color: 'var(--PrimaryText)', fontSize: '18px', fontWeight: 500 }}> { tagprop.name !== "Panel Door" ? tagprop.value === 1 ? 'ON' : 'OFF' : tagprop.value === 1 ? 'Close' : 'Open'} </Typography>
                            <div style={{width: '30px', height: '30px', borderRadius: '30px', border: '1px solid', backgroundColor: tagprop.name !== "Panel Door" ? tagprop.value === 1 ? '#DC272D' : '#A2A2A2' : tagprop.value === 1 ? 'green' : '#DC272D'}}>
                        
                            </div>
                            <div style={{marginTop: '5px'}}>
                                <Typography style={{color: 'var(--PrimaryText)', fontSize: '18px', fontWeight: 500 }}> {tagprop.name} </Typography>
                            </div>
                        </div>
                    )
                    
                })
            }
        </div>
    )
}